export const ESTADOS_VERIFICACION = {
  VERIFICADA: 1,
  NO_VERIFICADO: 2,
}

export const OPTIONS_ESTADO_VERIFICACION = [
  {
    label: "Verificada",
    value: ESTADOS_VERIFICACION.VERIFICADA,
  },
  {
    label: "No verificada",
    value: ESTADOS_VERIFICACION.NO_VERIFICADO,
  },
]

export const MODAL_TYPE_KEYS = {
  VERIFICACION_CESION: "VERTIFICAR CESION",
  ACEPTAR_CESION: "ACEPTAR CESION",
}

export const MODAL_TYPE_LOADING_SETUP = {
  [MODAL_TYPE_KEYS.VERIFICACION_CESION]: {
    title: "Verificación de factura cedida.",
    message: "Espere mientras se completa el proceso",
    type: MODAL_TYPE_KEYS.VERIFICACION_CESION,
    icon: "check",
    url: "",
  },
  [MODAL_TYPE_KEYS.ACEPTAR_CESION]: {
    title: "Aceptación de la cesión.",
    message: "Espere mientras se completa el proceso",
    type: MODAL_TYPE_KEYS.ACEPTAR_CESION,
    icon: "check",
    url: "",
  },
}

export const getModalTypeSetup = (nombreEntidad: $TSMigrationFixMe) => {
  return {
    content: {
      ...MODAL_TYPE_LOADING_SETUP[MODAL_TYPE_KEYS.ACEPTAR_CESION],
      title: nombreEntidad,
    },
  }
}

export const simulateFakeLoading = () =>
  new Promise((res) => setTimeout(res, 3000))

export const lazyRequest = async (apiRequest: $TSMigrationFixMe) =>
  simulateFakeLoading().then(() => apiRequest)
